import type {
  ArticleDto,
  AvailabilityDto,
  CreateRequestDto,
  HomeContentDto,
  PaginatedResponse,
} from '@lex/contracts';
import type { ApiClient } from './client';

export function createArticlesApi(client: ApiClient) {
  return {
    list(params?: { tag?: string; page?: number }): Promise<PaginatedResponse<ArticleDto>> {
      const qs = new URLSearchParams();
      if (params?.tag) qs.set('tag', params.tag);
      if (params?.page) qs.set('page', String(params.page));
      const suffix = qs.toString() ? `?${qs.toString()}` : '';
      return client.get(`/api/v1/articles${suffix}`, { auth: false });
    },
    get(slug: string): Promise<ArticleDto> {
      return client.get(`/api/v1/articles/${slug}`, { auth: false });
    },
  };
}

export function createSiteContentApi(client: ApiClient) {
  return {
    home(): Promise<HomeContentDto> {
      return client.get('/api/v1/content/home', { auth: false });
    },
    availability(): Promise<AvailabilityDto> {
      return client.get('/api/v1/content/availability', { auth: false });
    },
  };
}

export function createRequestsApi(client: ApiClient) {
  return {
    create(body: CreateRequestDto): Promise<{ ok: true; id: string }> {
      return client.post('/api/v1/requests', body, { auth: false });
    },
  };
}
